import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "ORDER_NOTE_CREATE_ERROR":
            return action.error;

        case "ORDER_NOTE_CREATE_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "ORDER_NOTE_CREATE_LOADING":
            return action.loading;

        case "ORDER_NOTE_CREATE_RESET":
            return false;

        default:
            return state;
    }
}

export function created(state = null, action) {
    switch (action.type) {
        case "ORDER_NOTE_CREATE_SUCCESS":
            return action.created;

        case "ORDER_NOTE_CREATE_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({error, loading, created});
